import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import Form from "../forms/form";
import MyCountdown from "../parts/countdown";

import 'animate.css';


function  BusinessStats() {

    return (
        <section className="py-[60px] lg:py-[120px] bg-[#faf9ff]">

            <div className="container max-w-[1340px] mx-auto px-5">

                <div className="md:grid md:grid-cols-2 gap-[clamp(32px,calc(32px+48*((100vw-390px)/1530)),80px)]">
                    <div className="mb-6 md:mb-0">
                        <h2 className="uppercase leading-[1.2] font-extrabold mb-4 xl:mb-[26px]
                            text-[clamp(24px,calc(24px+26*((100vw-390px)/1530)),50px)]">У бізнесі не всі відповіді потрібно шукати самостійно</h2>
                        <p className="leading-[1.2] text-base lg:text-lg md:mb-[30px]">
                            <strong>GET Business FEST</strong> створює простір, де досвід підприємців не залишається всередині окремих компаній. Приєднуйтесь до GET Business FEST, щоб побачити за цифрами реальні бізнес-кейси, рішення та досвід, які можна переосмислити для власної стратегії.
                        </p>
                        <div className="hidden md:block bisnes-form py-6 px-[15px] bg-white border border-[#babafe] rounded-tr-[100px]
                            lg:p-[40px]">
                            <MyCountdown/>
                            <Form/>
                        </div>
                    </div>

                    <div className="grid gap-[15px] xl:gap-[20px] mb-[35px] md:mb-0">
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px] rounded-tr-[150px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1 
                                xl:text-[60px]">63%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">підприємців, які планують зростання, хочуть розширити клієнтську базу</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]"> 
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1
                                xl:text-[60px]">59%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">підприємців потребують довгострокового фінансування для розвитку</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]  rounded-tr-[150px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1 
                                xl:text-[60px]">74%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">компаній називають дефіцит кваліфікованих кадрів значним викликом</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1
                                xl:text-[60px]">28%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">українських компаній уже працюють на зовнішніх ринках</p>
                        </div>
                    </div>
                </div>


                <div className="md:hidden bisnes-form py-6 px-[15px] bg-white border border-[#babafe] rounded-tr-[100px]">
                    <MyCountdown/>
                    <Form/>
                </div>

            </div>

        </section>
    )
}

export default BusinessStats;